import _uniqueId from "lodash/uniqueId";
import * as types from '../types';
const checkExercise = _ref => {
  let {
    exerciseId,
    isLoggedIn,
    lastSubmittedCode,
    message,
    success
  } = _ref;
  return {
    id: exerciseId,
    isLoggedIn,
    lastSubmittedCode,
    message,
    messageId: _uniqueId(),
    success,
    type: types.CHECK_EXERCISE
  };
};
export default checkExercise;